<embed [ngClass]="isLoading? 'display-none' : ''" (load)="onLoad()"
    src="https://webforms.pipedrive.com/f/6jZm3OlbwxfjokXx4supvq9fkbhLi6MHVfXAuxiKUEupZknE9CtkE03dMzQb6aj4dR" type="">


    <ng-container card-body>
        <div [style.margin]="'10rem 0'" [ngClass]="!isLoading? 'display-none' : ''" class="flex align-items-center justify-content-center">
            <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
        </div>
    </ng-container>
